import { fromJS } from 'immutable';

export const LOAD_INIT = 'broadband/LOAD_INIT';
export const LOAD_SUCCESS = 'broadband/LOAD_SUCCESS';
export const LOAD_FAIL = 'broadband/LOAD_FAIL';

export const LOAD_MBB_INIT = 'broadband/LOAD_MBB_INIT';
export const LOAD_MBB_SUCCESS = 'broadband/LOAD_MBB_SUCCESS';
export const LOAD_MBB_FAIL = 'broadband/LOAD_MBB_FAIL';

const ENDPOINT = '/api/broadbands';

const initialState = {
  offers: fromJS([])
};

export default function broadband(state = initialState, { type, payload }) {
  if (type === LOAD_SUCCESS) {
    return {
      ...state,
      offers: fromJS(payload.offers)
    };
  }
  if (type === LOAD_MBB_SUCCESS) {
    return {
      ...state,
      mbb: fromJS(payload.offers)
    };
  }

  return state;
}

export function getOffers() {
  return {
    types: [LOAD_INIT, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${ENDPOINT}/`)
  };
}

export function getMbb() {
  return {
    types: [LOAD_MBB_INIT, LOAD_MBB_SUCCESS, LOAD_MBB_FAIL],
    promise: client => client.get(`${ENDPOINT}/mbb`)
  };
}

export function isLoaded({ getState }) {
  return getState().broadband.offers.size;
}

export function serialize(state) {
  return state.offers.toJS();
}

export function deserialize(state) {
  if (state === null) {
    return initialState;
  }
  return {
    offers: fromJS(state)
  };
}
